import React from 'react';
import twMerge from 'utilities/src/twMerge';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export default function MainContainer({ children, className }: Props) {
  return (
    <section className={twMerge('mdS:mx-6 mdL:mx-8 mx-4 lg:mx-auto lg:max-w-[76rem]', className)}>
      {children}
    </section>
  );
}
